export const SURVEY_EDITOR_PARTICIPANT_RESULT_PATH =
  "/surveys-editor/:surveyId/participants/:participantId";
